import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setRendererFormState } from "../../../../slices/common/reducer";
import rootReducer from "../../../../store";
import FormGroupWrapper from "./FormGroupWrapper";
import { labelUtils } from "../Util";
import Select from "react-select";

const CustomYear = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState = {},
  displayLabelKey,
  databaseKey,
  showRequired = true,
}) => {
  const dispatch = useDispatch();
  const key = databaseKey || displayLabelKey;
  const required = showRequired ? fieldEle?.["display-required"] === 1 : false;
  const disabled = fieldEle?.["display-disabled"] === 1;
  const description = fieldEle?.["display-description"];
  const allowFutureDates = fieldEle?.["allowFutureDates"] === 1;
  const displayYes = fieldEle?.["display-yes"];
  const parentSelected = displayYes ? formState[displayYes] : "";
  const shouldDisplay = parentSelected?.toLowerCase() === "yes";

  const [options, setOptions] = useState([]);
  const [error, setError] = useState("");

  // Generate year options
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const startYear = 1900;
    const endYear = allowFutureDates ? currentYear + 50 : currentYear;
    const yearsArray = Array.from(
      { length: endYear - startYear + 1 },
      (_, i) => startYear + i
    ).reverse();

    const yearOptions = yearsArray.map((year) => ({
      value: year,
      label: year.toString(),
    }));

    setOptions(yearOptions);
  }, [allowFutureDates]);

  // Extract selected year from stored date format "01-01-YYYY"
  const savedValue = formState[key];
  // const selectedYear =
  //   savedValue && /^\d{2}-\d{2}-\d{4}$/.test(savedValue)
  //     ? savedValue.split("-")[2]
  //     : "";
  let selectedYear = "";

  if (savedValue) {
    if (/^\d{4}-\d{2}-\d{2}$/.test(savedValue)) {
      selectedYear = savedValue.split("-")[0];
    } else if (/^\d{2}-\d{2}-\d{4}$/.test(savedValue)) {
      selectedYear = savedValue.split("-")[2];
    }
  }

  const selectedOption = selectedYear
    ? { value: selectedYear, label: selectedYear }
    : null;

  // Reset field if display condition hides it
  useEffect(() => {
    if (displayYes && shouldDisplay === false) {
      rootReducer.dispatch(
        setRendererFormState({ key: databaseKey, value: "" })
      );
    }
  }, [displayYes, shouldDisplay, databaseKey]);

  // Handle year change
  const handleChange = (selectedOption) => {
    const selectedYear = selectedOption ? selectedOption.value : "";
    const formattedDate = selectedYear ? `01-01-${selectedYear}` : "";
    dispatch(setRendererFormState({ key, value: formattedDate }));
    setError("");
  };

  // Validate on blur
  const handleBlur = () => {
    const fieldValue = formState[key];
    if (required && (!fieldValue || fieldValue === "")) {
      setError("This field is required");
    } else {
      setError("");
    }
  };

  if (displayYes && !shouldDisplay) {
    return null;
  }

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        {/* hidden input for native validation */}
        <div style={{ display: "none" }}>
          <input
            type="text"
            required={required}
            value={formState[key] || ""}
            onChange={(e) => handleChange({ value: e.target.value })}
          />
        </div>

        <Select
          id={newElfromJSON}
          placeholder={fieldEle?.["display-placeholder"] || "Select Year"}
          value={selectedOption}
          onChange={handleChange}
          onBlur={handleBlur}
          isDisabled={disabled}
          isClearable
          className="mandatory"
          options={options}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 1050 }),
          }}
        />

        {error && <div style={{ color: "red", fontSize: "12px" }}>{error}</div>}

        {description && (
          <div className="form-text text-muted formElementDesc">
            {description}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};

export default CustomYear;
